import styled from 'styled-components';

import { Sorare } from 'atoms/icons/Sorare';

export const FootballLogo = styled(Sorare)`
  color: var(--c-brand-600);
  fill: var(--c-black);
`;
